<template>
  <v-app>
    <v-container class="my-16">
      <v-row justify="start">
        <v-col cols="12" md="3">
          <v-alert text outlined color="deep-orange" icon="mdi-fire">
            {{userId}}
           Имэйл, болон утасны дугаарыг заавал оруулаx xэрэгтэйг анxаарна уу!
          </v-alert>
        </v-col>
        <v-col cols="12" md="6">
          <my-setting
            v-bind:isRegistering="false"
            v-bind:userId="userId"
            :toClose=toClose
          ></my-setting>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import MySetting from "@/views/MySetting";
import { mapState } from "vuex";
const fb = require("../../firebaseConfig.js");
export default {
  name: "EditUser",
  data: () => ({}),
  components: {
    MySetting,
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
  },
  created() {},
  methods: {},
  props: {
    userId: {
      type: String,
      required: true,
    },
    toClose: {
      type: Boolean,
      required: true,
    },
  },
};
</script>
